module.exports = __webpack_public_path__ + "static/img/default_new_en-US.809f9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/v2/default/default_new_en-US.png
// module id = KJ/u
// module chunks = 24